import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { BioSampleServiceConfig } from './biosample-service.types';

export function provideBioSampleService(config: BioSampleServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'bioSampleServiceConfig', useValue: config }
  ]);
}
